import React from 'react';

import styled from '@emotion/styled';

interface ContactsCardProps {
  data: {
    label: string;
    description: string;
    value: string;
  };
}

const ContactsCard: React.FC<ContactsCardProps> = ({ data }) => {
  return (
    <Container>
      <Label>{data.label}</Label>
      <Description>{data.description}</Description>
    </Container>
  );
};

export default ContactsCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const Description = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
